import { render, staticRenderFns } from "./ListDoumentMatter.vue?vue&type=template&id=134d90dd"
import script from "./ListDoumentMatter.vue?vue&type=script&lang=js"
export * from "./ListDoumentMatter.vue?vue&type=script&lang=js"
import style0 from "./ListDoumentMatter.vue?vue&type=style&index=0&id=134d90dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports